import { useSelector } from 'react-redux';
import { styled } from '../styled';

const Wrap = styled('div')({
  padding: 32,
  textAlign: 'center',
  color: 'var(--qhs-text-3)',
  fontSize: 13,
});

const CatalogEmpty = ({ query, itemsLabel }) => {
  const { catalog } = useSelector(state => state.i18n);
  const message = query
    ? catalog.noMatchesFor.replace('{{query}}', query)
    : `No ${itemsLabel ?? 'items'}`;
  return <Wrap>{message}</Wrap>;
};

export default CatalogEmpty;
